<template>
  <div fluid :class="$vuetify.breakpoint.mdAndUp ? 'px-5' : 'px-3'">
    <v-col cols="12" class="px-3 mb-2">
      <v-row>
        <v-col cols="12">
          <v-textarea v-model="dDescription"  
                      auto-grow 
                      :id="('dDescription')" 
                      :label="$t('datGeneric.description')+'*'"
                      item-color="datPrimary" 
                      color="datPrimary" 
                      class="mt-0" 
                      rows="2" />
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-btn depressed class="datPrimaryBtn ma-3" @click="fSetComplaintComment">
          {{$t('datBtn.save')}}
        </v-btn>
      </v-row>
    </v-col>
  </div>
</template>

<script>

// Servicios
import ServiceEcomplaints from '@/services/srv-eComplaints'
import ServiceEcomplaintsPublic from '@/services/srv-eComplaintsPublic'

export default {

  data () {
    return {
      dDescription: null,
      dExternalOrigin: localStorage.getItem("externOrigin") 
    }
  },

  props:{
    pComplaintInfo:{
      type: Object,
      required: true
    },
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    },    
  },

  methods: {
    // Guarda el nuevo comentario
    fSetComplaintComment(){
      const payload = {
        complaintId: this.pComplaintInfo.complaintId,
        description: this.dDescription,
      }

      if(this.dDescription == null || this.dDescription.trim() === '') {
        this.fSnackbarError(this.$t('datError.fillAllData'), this.pShowSnackbar)

      }else if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.setComplaintComment(payload).then((response) =>{
          if (response.statusCode == '200' && response.result != 'ko'){
            this.fSnackBarSuccess( this.$t('datAlert.newCommnent'))
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        }).finally(() =>{
          this.fClose(true)
        })

      }else{
        ServiceEcomplaints.setComplaintComment(payload).then((response) =>{
          if (response.statusCode == '200' && response.result != 'ko'){
            this.fSnackBarSuccess( this.$t('datAlert.newCommnent'))
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        }).finally(() =>{
          this.fClose(true)
        })
      }
    },

    // Cierra el componente de logs
    fClose(update){
      this.$emit('close', update)
    }
  }
}
</script>

 